/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Meta_SyncingInputs */

const es_chat_meta_syncing = /** @type {(inputs: Chat_Meta_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizando`)
};

const en_chat_meta_syncing = /** @type {(inputs: Chat_Meta_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syncing`)
};

/**
* | output |
* | --- |
* | "Syncing" |
*
* @param {Chat_Meta_SyncingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_meta_syncing = /** @type {((inputs?: Chat_Meta_SyncingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Meta_SyncingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_meta_syncing(inputs)
	return en_chat_meta_syncing(inputs)
});
export { chat_meta_syncing as "chat.meta.syncing" }